/** Client-only role preview (Administrator). Does not change Cognito or platform user. */

export const ADMINISTRATOR_ROLE_ID = 'role_administrator';

export const IMPERSONATION_STORAGE_KEY = 'pulse.admin.impersonateRole';

export type RoleImpersonation = {
  roleId: string;
  roleName: string;
  permissions: string[];
  allowedAgentIds: string[];
};

export function isAdministratorProfile(profile: {
  roleId?: string;
} | null | undefined): boolean {
  return String(profile?.roleId || '') === ADMINISTRATOR_ROLE_ID;
}

export function getImpersonation(): RoleImpersonation | null {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(IMPERSONATION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as RoleImpersonation;
    if (!parsed?.roleId || !Array.isArray(parsed.permissions)) return null;
    return {
      roleId: String(parsed.roleId),
      roleName: String(parsed.roleName || 'Role'),
      permissions: parsed.permissions.map(String),
      allowedAgentIds: Array.isArray(parsed.allowedAgentIds)
        ? parsed.allowedAgentIds.map(String).filter(Boolean)
        : [],
    };
  } catch {
    return null;
  }
}

export function startImpersonation(role: {
  roleId: string;
  name: string;
  permissions?: string[];
  allowedAgentIds?: string[];
}): RoleImpersonation {
  const payload: RoleImpersonation = {
    roleId: String(role.roleId),
    roleName: String(role.name || 'Role'),
    permissions: Array.isArray(role.permissions) ? role.permissions.map(String) : [],
    allowedAgentIds: Array.isArray(role.allowedAgentIds)
      ? role.allowedAgentIds.map(String).filter(Boolean)
      : [],
  };
  sessionStorage.setItem(IMPERSONATION_STORAGE_KEY, JSON.stringify(payload));
  return payload;
}

export function clearImpersonation(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(IMPERSONATION_STORAGE_KEY);
}

export const IMPERSONATION_CHANGED_EVENT = 'pulse-admin-impersonation-changed';

export function notifyImpersonationChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(IMPERSONATION_CHANGED_EVENT));
}
